import { ICON_BUTTON_ICONS } from '../../../buttons/IconButton';

export default [
  {
    name: 'Relevance (default)',
    shortName: 'Relevance (default)',
    value: 'default',
    onlyForSearchType: 'all'
  },
  {
    name: 'Company name (a → z)',
    shortName: 'Company name',
    value: 'name-asc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN
  },
  {
    name: 'Company name (z → a)',
    shortName: 'Company name',
    value: 'name-desc',
    icon: ICON_BUTTON_ICONS.SORT_ALPHA_DOWN_ALT
  },
  {
    name: 'Sales (1 → 9)',
    shortName: 'Sales',
    value: '_revenue-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN
  },
  {
    name: 'Sales (9 → 1)',
    shortName: 'Sales',
    value: '_revenue-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT
  },
  {
    name: 'EBIT-Margin (1 → 9)',
    shortName: 'EBIT-Margin',
    value: '_ebitPercentage-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN
  },
  {
    name: 'EBIT-Margin (9 → 1)',
    shortName: 'EBIT-Margin',
    value: '_ebitPercentage-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT
  },
  {
    name: 'Employees (1 → 9)',
    shortName: 'Employees',
    value: '_employees-asc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN
  },
  {
    name: 'Employees (9 → 1)',
    shortName: 'Employees',
    value: '_employees-desc',
    icon: ICON_BUTTON_ICONS.SORT_NUMERIC_DOWN_ALT
  }
];
